import React from 'react';
import PropTypes from 'prop-types';
import { User, Landmark } from 'lucide-react';

// Base
import Button from '../../../base/button';
import Card from '../../../base/card';
import CircleLucide from '../../../base/circled_lucide';
import Separator from '../../../base/separator';

// Related Components
import LogoutLogo from '../../../agents/subscribe/logout_logo';

export default class UserType extends React.Component {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    onSetView: PropTypes.func.isRequired,
    onSignIn: PropTypes.func,
  }

  handleSelect = (userType) => {
    const { onUpdate } = this.props;

    onUpdate(userType);
  }

  render() {
    const { onSignIn } = this.props;

    return (
      <React.Fragment>
        <div className='height-60 margin-bottom-70'>
          <LogoutLogo />
        </div>

        <div className='width-560 margin-center'>
          <img
            src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/layout/logo_square.png`}
            className='margin-bottom-24'
            alt='Oomple'
          />

          <div className='margin-bottom-10 xlg-font semi-bold line-height-26'>
            Welcome to Oomple, Join Today!
          </div>

          <Separator className='margin-top-0 margin-bottom-30' />

          <div className='lg-font tertiary-color semi-bold line-height-32 margin-bottom-25'>
            Let us know, how do you plan on using Oomple?
          </div>

          <div className='margin-bottom-25'>
            <Card
              border='thin'
              className='min-height-0 height-95 vertical-align'
              hoverable
              onClick={() => this.handleSelect('consultant')}
            >
              <div>
                <CircleLucide
                  icon={<User size={30} />}
                  className='primary-color secondary-background'
                />
              </div>

              <div className='margin-left-20'>
                <div className='sm-font med-bold'>
                  Find My Next Contract
                </div>

                <div className='xxsm-font margin-top-8 med-bold gray-1000'>
                  I&apos;m a consultant or professional seeking contracts,
                  showcasing skills, and growing my career.
                </div>
              </div>
            </Card>
          </div>

          <div className='margin-bottom-25'>
            <Card
              border='thin'
              className='min-height-0 height-95 vertical-align'
              hoverable
              onClick={() => this.handleSelect('agent')}
            >
              <div>
                <CircleLucide
                  icon={<Landmark size={30} />}
                  className='primary-color secondary-background'
                />
              </div>

              <div className='margin-left-20'>
                <div className='sm-font med-bold'>
                  Engage &amp; Deploy Consultants
                </div>

                <div className='xxsm-font margin-top-8 med-bold gray-1000'>
                  I&apos;m a consulting firm, or staffing agency looking to
                  connect with skilled consultants.
                </div>
              </div>
            </Card>
          </div>

          <div className='margin-top-30 center-align sm-font'>
            Have an account?{' '}
            <Button {...{
              ...(onSignIn ? { onClick: onSignIn } : { to: '/users/sign_in' }),
              className: 'sm-font margin-top-30 underline',
              text: 'Log in',
              size: 'custom',
            }} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
